import {
  AllocationValueTypeEnum,
  FieldValidationLevel,
  type FieldValidationRule,
  type NumericField,
} from '@talos/kyoko';
import Big from 'big.js';
import type { WritableDraft } from 'immer';
import type { ManualDealTradeForm } from '../types';

// Custom validation for allocations - handles both percentage and quantity modes
export const allocationTotalValidation: FieldValidationRule<NumericField, WritableDraft<ManualDealTradeForm>> = (
  field,
  context
) => {
  if (!context) {
    return null;
  }

  const allocations = context.allocations.map(pair => pair.valueField.bigValue || new Big(0));
  const sum = allocations.reduce((total, value) => total.plus(value), new Big(0));
  const valueType = context.allocationValueTypeField.value;

  // Get the appropriate field based on form type
  let totalValue = new Big(0);
  if ('notionalAmountField' in context) {
    totalValue = new Big(context.notionalAmountField.value || 0);
  }

  if (!field.hasValue || field.value === '0') {
    return {
      message: `${field.name} cannot be 0`,
      level: FieldValidationLevel.Error,
    };
  }

  if (valueType === AllocationValueTypeEnum.Percentage) {
    if (sum.gt(1)) {
      return {
        message: 'Total cannot exceed 100%',
        level: FieldValidationLevel.Error,
      };
    }
    if (sum.lt(1)) {
      return {
        message: 'Total must add up to 100%',
        level: FieldValidationLevel.Error,
      };
    }
  } else {
    if (sum.gt(totalValue)) {
      return {
        message: 'Total cannot exceed Notional Amount',
        level: FieldValidationLevel.Error,
      };
    }
    if (sum.lt(totalValue)) {
      return {
        message: 'Total must add up to Notional Amount',
        level: FieldValidationLevel.Error,
      };
    }
  }

  return null;
};
